<div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="24px">
    <div class="dsh-accordion-item-content-header-label" fxFlex="grow"><ng-content></ng-content></div>
    <button dsh-icon-button (click)="collapse.emit($event)">
        <dsh-bi icon="chevron-up"></dsh-bi>
    </button>
</div>
